<template>
  <div :class="[d_fullScreen ? 'full-screen-mode' : 'normal-mode']">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="4" lg="11">
        <i class="fa fa-file-text-o"></i>
        <strong style="margin-left: 10px;">{{ StoreLangTranslation.data['report_management'][StoreLang] }}</strong>
      </b-col>
      <b-col sm="12" lg="1">
        <b-button class="pull-right" size="lg" variant="white" @click="d_fullScreen ? d_fullScreen = false : d_fullScreen = true">
          <i class="fa fa-desktop"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row :style="d_fullScreen ? 'margin-top: 50px;' : 'margin: 0px;'">
      <b-col cols="3">
        <div class="report-tab-list" style="height: 650px; overflow-y: scroll;">
          
          <div @click="f_selectedTab('new_report', '')" class="report-tab-item" :class="{ active: d_selectedTab === 'new_report', disabled: d_reportLoading }"> 
            {{ 'new report' }}
          </div>
          <hr/>
          <div @click="f_selectedTab('banned_ip_list', '')" class="report-tab-item" :class="{ active: d_selectedTab === 'banned_ip_list', disabled: d_reportLoading }"> 
            {{ StoreLangTranslation.data['banned_ip_list'][StoreLang] }}
          </div>
          <div @click="f_selectedTab('banned_session_list', '')" class="report-tab-item" :class="{ active: d_selectedTab === 'banned_session_list', disabled: d_reportLoading }"> 
            {{ StoreLangTranslation.data['banned_session_list'][StoreLang] }}
          </div>
          <hr/>
          <div @click="f_selectedTab('list_based_query', '')" class="report-tab-item" :class="{ active: d_selectedTab === 'list_based_query', disabled: d_reportLoading }"> 
            {{ StoreLangTranslation.data['list_based_query'][StoreLang] }}
          </div>
          <hr/>
          <div v-for="(tab, tab_index) in d_tabList" @click="f_selectedTab('report', tab_index)" class="report-tab-item" :class="{ active: d_selectedTabIndex === tab_index, disabled: d_reportLoading }" :key="'tab_' + tab_index"> 
            <b-row>
              <b-col cols="9" style="word-break: break-word; white-space: normal;">
                {{ tab.name }}
              </b-col>
              <b-col cols="3">
                <i class="fa fa-minus" style="color: red; float: right; cursor: pointer; border: 1px solid red; border-radius: 50%; padding: 3px 5px;" @click="f_removeTab(tab_index, $event)"></i>
              </b-col>
            </b-row>

          </div>


        </div>
      </b-col>

      <b-col cols="9">

        <template v-if="d_selectedTab === 'new_report'">
          <b-container fluid class="report-key-builder">

            <b-card class="mb-3" header="Report Key Builder">

              <!-- 1️⃣ SCOPE (system / web) -->
              <b-row class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Scope</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_selectedScope">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>
                    <!-- <b-form-select-option value="system">system</b-form-select-option> -->
                    <b-form-select-option value="web">web</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 2️⃣ WEB TYPE -->
              <b-row v-if="d_selectedScope === 'web'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Web Type</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_selectedWebType">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>
                    <b-form-select-option value="all">all</b-form-select-option>
                    <b-form-select-option value="user">user</b-form-select-option>
                    <b-form-select-option value="ip">ip</b-form-select-option>
                    <b-form-select-option value="session">session</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 3️⃣ DAY BASED -->
              <b-row v-if="d_selectedScope" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Day Bazlı</label>
                </b-col>
                <b-col cols="8">
                  <b-form-checkbox v-model="d_isDayBased">day bazlı</b-form-checkbox>
                </b-col>
              </b-row>

              <!-- 🟢 DAY TYPE -->
              <b-row v-if="d_isDayBased" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Day Type</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_dayType">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>
                    <b-form-select-option value="today">today</b-form-select-option>
                    <b-form-select-option value="last_x_days">last x days</b-form-select-option>
                    <b-form-select-option value="between_two_days">between 2 days</b-form-select-option>
                    <b-form-select-option value="one_day">one day</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 🟡 LAST X DAYS -->
              <b-row v-if="d_isDayBased && d_dayType === 'last_x_days'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Last X Days</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input type="number" min="1" v-model="d_form.last_x_days" placeholder="örn: 5" />
                </b-col>
              </b-row>

              <!-- 🔵 BETWEEN TWO DAYS -->
              <b-row v-if="d_isDayBased && d_dayType === 'between_two_days'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Start Date (YYYYMMDD)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form.start_date" />
                </b-col>
              </b-row>

              <b-row v-if="d_isDayBased && d_dayType === 'between_two_days'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">End Date (YYYYMMDD)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form.end_date" />
                </b-col>
              </b-row>

              <!-- 🔵 ONE DAY -->
              <b-row v-if="d_isDayBased && d_dayType === 'one_day'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Date (YYYYMMDD)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form.one_date" />
                </b-col>
              </b-row>

              <!-- 4️⃣ TYPE -->
              <b-row v-if="d_selectedScope === 'system' || (d_selectedScope === 'web' && d_selectedWebType && !d_isDayBased)" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Rapor Tipi</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_selectedType">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>

                    <!-- SYSTEM -->
                    <template v-if="d_selectedScope === 'system'">
                      <b-form-select-option v-for="(tpl, type) in d_reportModels.system.types" :key="'sys_' + type" :value="type">
                        {{ type }}
                      </b-form-select-option>
                    </template>

                    <!-- WEB -->
                    <template v-if="d_selectedScope === 'web' && d_selectedWebType">
                      <b-form-select-option v-for="(tpl, type) in d_reportModels.web[d_selectedWebType].types" :key="'web_' + type" :value="type">
                        {{ type }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 5️⃣ TARGET INPUTLAR -->

              <!-- SYSTEM -->
              <b-row v-if="d_selectedScope === 'system'" v-for="field in d_reportModels.system.targets" :key="'sys_field_' + field" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">{{ field }}</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form[field]" />
                </b-col>
              </b-row>

              <!-- WEB (user / ip / session) -->
              <template v-if="d_selectedScope === 'web' && d_selectedWebType && d_selectedWebType !== 'all'">
                <!-- Zorunlu targets -->
                <b-row v-for="field in d_reportModels.web[d_selectedWebType].targets" :key="'web_field_' + field" class="align-items-center mb-3">
                  <b-col cols="4">
                    <label class="mb-0 font-weight-bold">{{ field }}</label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input v-model="d_form[field]" />
                  </b-col>
                </b-row>

                <!-- Opsiyonel targets (process_name) -->
                <b-row v-for="field in (d_reportModels.web[d_selectedWebType].targets_optional || [])" :key="'web_optional_' + field" class="align-items-center mb-3">
                  <b-col cols="4">
                    <label class="mb-0 font-weight-bold">{{ field }} (opsiyonel)</label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-select v-model="d_form[field]">
                      <b-form-select-option value="">seçilmedi</b-form-select-option>
                      <b-form-select-option v-for="(route, i) in d_routeList" :key="i" :value="route">
                        {{ route }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </template>

              <!-- WEB ALL → process_name opsiyonel -->
              <b-row v-if="d_selectedScope === 'web' && d_selectedWebType === 'all'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">process_name (opsiyonel)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_form.process_name">
                    <b-form-select-option value="">seçilmedi</b-form-select-option>
                    <b-form-select-option v-for="(route, i) in d_routeList" :key="i" :value="route">
                      {{ route }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- OLUŞAN KEY / OBJE -->
              <b-card v-if="f_build_report_object()" bg-variant="light" border-variant="primary">
                <!-- 🔴 RAPOR ADI -->
                <b-row class="mt-3 align-items-center">
                  <b-col cols="4">
                    <label class="mb-0 font-weight-bold">Rapor Adı</label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input v-model="d_newReportName" placeholder="Rapor adı giriniz" />
                  </b-col>
                </b-row>

                <!-- Preview -->
                <b-row class="align-items-center" style="margin-top: 20px;">
                  <b-col cols="4">
                    Oluşan Rapor Obj.
                  </b-col>
                  <b-col cols="8">
                    <b-form-textarea readonly rows="5" class="font-monospace" :value="JSON.stringify(f_build_report_object(), null, 2)" />
                  </b-col>
                </b-row>

                <!-- EKLE -->
                <b-row class="mt-3">
                  <b-col sm="12" lg="8"></b-col>
                  <b-col sm="12" lg="2">
                    <b-button variant="warning" block @click="f_resetReportBuilder()">
                      Reset
                    </b-button>
                  </b-col>
                  <b-col sm="12" lg="2">
                    <b-button variant="success" block :disabled="!d_newReportName" @click="f_addReportTab()">
                      Ekle
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>

            </b-card>
          </b-container>
        </template>


        <template v-else-if="d_selectedTab === 'banned_ip_list'">
          <template slot="title">
            {{ StoreLangTranslation.data['banned_ip_list'][StoreLang] }}
          </template>
          <b-row>
            <b-col sm="12" md="12" lg="2">
            </b-col>
            <b-col sm="12" md="12" lg="8">
             <i class="fa fa-info-circle"></i>
              Bu rapor sistemde banı bulunan ip'leri içerir.
            </b-col>
            <b-col sm="12" md="12" lg="2">
            </b-col>
          </b-row>
          <template v-if="d_bannedIpList.length > 0" style="max-width: 800px;">
            <b-row style="padding: 10px 0px;">
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                <strong>
                  BANNED IP LIST
                </strong>
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
            <b-row v-for="banned_ip in d_bannedIpList">
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                {{ banned_ip.ip }} - {{ banned_ip.last_block_date }}
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
          </template>
          <template v-else-if="!d_reportLoading">
            <b-row>
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                <span>{{ StoreLangTranslation.data['no_banned_ip'][StoreLang] }}</span>
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-row>
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
          </template>
        </template>

        <template v-else-if="d_selectedTab === 'banned_session_list'">
          <template slot="title">
            {{ StoreLangTranslation.data['banned_session_list'][StoreLang] }}
          </template>
          <b-row>
            <b-col sm="12" md="12" lg="2">
            </b-col>
            <b-col sm="12" md="12" lg="8">
             <i class="fa fa-info-circle"></i>
              Bu rapor sistemde banı bulunan session'ları içerir.
            </b-col>
            <b-col sm="12" md="12" lg="2">
            </b-col>
          </b-row>
          <template v-if="d_bannedSessionList.length > 0" style="max-width: 800px;">
            <b-row style="padding: 10px 0px;">
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                <strong>
                  BANNED SESSION LIST
                </strong>
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
            <b-row v-for="banned_session in d_bannedSessionList">
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                {{ banned_session.ip }} - {{ banned_session.session }} - {{ banned_session.last_block_date }}
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
          </template>
          <template v-else-if="!d_reportLoading">
            <b-row>
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                <span>{{ StoreLangTranslation.data['no_banned_session'][StoreLang] }}</span>
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-row>
              <b-col sm="12" md="12" lg="2">
              </b-col>
              <b-col sm="12" md="12" lg="8">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </b-col>
              <b-col sm="12" md="12" lg="2">
              </b-col>
            </b-row>
          </template>
        </template>

        <template v-if="d_selectedTab === 'list_based_query'">
          <b-container fluid class="report-key-builder">

            <b-card class="mb-3" header="Report Key Builder">

              <!-- 1️⃣ SCOPE (system / web) -->
              <b-row class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Scope</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_selectedScope">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>
                    <!-- <b-form-select-option value="system">system</b-form-select-option> -->
                    <b-form-select-option value="web">web</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 2️⃣ WEB TYPE -->
              <b-row v-if="d_selectedScope === 'web'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Web Type</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_selectedWebType">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>
                    <!-- <b-form-select-option value="all">all</b-form-select-option> -->
                    <b-form-select-option value="user">user</b-form-select-option>
                    <b-form-select-option value="ip">ip</b-form-select-option>
                    <b-form-select-option value="session">session</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 3️⃣ DAY BASED -->
              <b-row v-if="d_selectedScope" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Day Bazlı</label>
                </b-col>
                <b-col cols="8">
                  <b-form-checkbox v-model="d_isDayBased">day bazlı</b-form-checkbox>
                </b-col>
              </b-row>

              <!-- 🟢 DAY TYPE -->
              <b-row v-if="d_isDayBased" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Day Type</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_dayType">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>
                    <b-form-select-option value="today">today</b-form-select-option>
                    <b-form-select-option value="last_x_days">last x days</b-form-select-option>
                    <b-form-select-option value="between_two_days">between 2 days</b-form-select-option>
                    <b-form-select-option value="one_day">one day</b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 🟡 LAST X DAYS -->
              <b-row v-if="d_isDayBased && d_dayType === 'last_x_days'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Last X Days</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input type="number" min="1" v-model="d_form.last_x_days" placeholder="örn: 5" />
                </b-col>
              </b-row>

              <!-- 🔵 BETWEEN TWO DAYS -->
              <b-row v-if="d_isDayBased && d_dayType === 'between_two_days'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Start Date (YYYYMMDD)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form.start_date" />
                </b-col>
              </b-row>

              <b-row v-if="d_isDayBased && d_dayType === 'between_two_days'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">End Date (YYYYMMDD)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form.end_date" />
                </b-col>
              </b-row>

              <!-- 🔵 ONE DAY -->
              <b-row v-if="d_isDayBased && d_dayType === 'one_day'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Date (YYYYMMDD)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form.one_date" />
                </b-col>
              </b-row>

              <!-- 4️⃣ TYPE -->
              <b-row v-if="d_selectedScope === 'system' || (d_selectedScope === 'web' && d_selectedWebType && !d_isDayBased)" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">Rapor Tipi</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_selectedType">
                    <b-form-select-option disabled value="">seçiniz</b-form-select-option>

                    <!-- SYSTEM -->
                    <template v-if="d_selectedScope === 'system'">
                      <b-form-select-option v-for="(tpl, type) in d_reportModels.system.types" :key="'sys_' + type" :value="type">
                        {{ type }}
                      </b-form-select-option>
                    </template>

                    <!-- WEB -->
                    <template v-if="d_selectedScope === 'web' && d_selectedWebType">
                      <b-form-select-option v-for="(tpl, type) in d_reportModels.web[d_selectedWebType].types_for_list" :key="'web_' + type" :value="type">
                        {{ type }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- 5️⃣ TARGET INPUTLAR -->

              <!-- SYSTEM -->
              <!-- <b-row v-if="d_selectedScope === 'system'" v-for="field in d_reportModels.system.targets" :key="'sys_field_' + field" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">{{ field }}</label>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="d_form[field]" />
                </b-col>
              </b-row> -->

              <!-- WEB (user / ip / session) -->
              <template v-if="d_selectedScope === 'web' && d_selectedWebType && d_selectedWebType !== 'all'">
                <!-- Zorunlu targets -->
                <!-- <b-row v-for="field in d_reportModels.web[d_selectedWebType].targets" :key="'web_field_' + field" class="align-items-center mb-3">
                  <b-col cols="4">
                    <label class="mb-0 font-weight-bold">{{ field }}</label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input v-model="d_form[field]" />
                  </b-col>
                </b-row> -->

                <!-- Opsiyonel targets (process_name) -->
                <b-row v-for="field in (d_reportModels.web[d_selectedWebType].targets_optional || [])" :key="'web_optional_' + field" class="align-items-center mb-3">
                  <b-col cols="4">
                    <label class="mb-0 font-weight-bold">{{ field }} (opsiyonel)</label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-select v-model="d_form[field]">
                      <b-form-select-option value="">seçilmedi</b-form-select-option>
                      <b-form-select-option v-for="(route, i) in d_routeList" :key="i" :value="route">
                        {{ route }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </template>

              <!-- WEB ALL → process_name opsiyonel -->
              <b-row v-if="d_selectedScope === 'web' && d_selectedWebType === 'all'" class="align-items-center mb-3">
                <b-col cols="4">
                  <label class="mb-0 font-weight-bold">process_name (opsiyonel)</label>
                </b-col>
                <b-col cols="8">
                  <b-form-select v-model="d_form.process_name">
                    <b-form-select-option value="">seçilmedi</b-form-select-option>
                    <b-form-select-option v-for="(route, i) in d_routeList" :key="i" :value="route">
                      {{ route }}
                    </b-form-select-option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- OLUŞAN KEY / OBJE -->
              <b-card v-if="true" bg-variant="light" border-variant="primary">
                <!-- 🔴 RAPOR ADI -->
                <!-- <b-row class="mt-3 align-items-center">
                  <b-col cols="4">
                    <label class="mb-0 font-weight-bold">Rapor Adı</label>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input v-model="d_newReportName" placeholder="Rapor adı giriniz" />
                  </b-col>
                </b-row> -->

                <!-- Preview -->
                <!-- <b-row class="align-items-center" style="margin-top: 20px;">
                  <b-col cols="4">
                    Oluşan Rapor Obj.
                  </b-col>
                  <b-col cols="8">
                    <b-form-textarea readonly rows="5" class="font-monospace" :value="JSON.stringify(f_build_report_object(), null, 2)" />
                  </b-col>
                </b-row> -->

                <!-- EKLE -->
                <b-row class="mt-3">
                  <b-col sm="12" lg="8"></b-col>
                  <b-col sm="12" lg="2">
                    <b-button variant="warning" block @click="f_resetReportBuilder()">
                      Reset
                    </b-button>
                  </b-col>
                  <b-col sm="12" lg="2">
                    <b-button variant="success" block @click="f_listBasedQuery()">
                      Sorgula
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>

            </b-card>
          </b-container>
          <div v-if="d_reportLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <div v-else-if="d_listQueryReportList.length > 0 ||d_listQueryMergedReportList.length > 0">
            <b-row style="margin: 3px; padding: 0px 20px;">
              <b-col cols="6">
                <strong>name</strong>
              </b-col>
              <b-col cols="3">
                <strong>count</strong>
              </b-col>
              <b-col cols="3">
                <strong style="float: right;">add</strong>
              </b-col>
            </b-row>
            <hr/>
            <template v-for="report_item in d_listQueryReportList">
              <b-row style="margin: 3px; padding: 0px 20px;">
                <b-col cols="6">
                  {{ report_item.data['0'][d_reportTypeMatch[d_listQueryReportType]]['val'] }}
                </b-col>
                <b-col cols="3">
                  {{ report_item.data['0']['6']['val'] }}
                </b-col>
                <b-col cols="3">
                  <b-button @click="f_addLastWeekReport(report_item.data['0'][d_reportTypeMatch[d_listQueryReportType]]['val'])" variant="outline-primary" style="float: right;">
                    ekle
                  </b-button>
                </b-col>

              </b-row>
              <hr/>
            </template>
            <template v-for="report_item in d_listQueryMergedReportList">
              <b-row style="margin: 3px; padding: 0px 20px;">
                <b-col cols="6">
                  {{ report_item['client_id'] }}
                </b-col>
                <b-col cols="3">
                  {{ report_item['count'] }}
                </b-col>
                <b-col cols="3">
                  <b-button @click="f_addLastWeekReport(report_item['client_id'])" variant="outline-primary" style="float: right;">
                    ekle
                  </b-button>
                </b-col>

              </b-row>
              <hr/>
            </template>
          </div>
        </template>

        <template v-else-if="d_selectedTab === 'report'">
          <b-row style="margin: 3px;">
            <b-col cols="6">
              <div :style="{ visibility: d_reportLoading ? 'visible' : 'hidden' }">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
            </b-col>
            <b-col cols="6">
              <div style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
                <span>{{ StoreLangTranslation.data['refresh_time_sec'][StoreLang] }}:</span>
                <b-form-input type="number" :style="d_changeTime ? 'border: 1px solid green' : 'border: 1px solid red'" v-model="d_refreshIntervalSecTemp"style="width: 100px;">
                </b-form-input>
              </div>
            </b-col>
          </b-row>
          <template v-if="d_selectedReportList.length > 0" style="max-width: 800px;">
            <b-row>
              <b-col sm="12" md="12" lg="12">
                <analyze-report-view :p_analyzeReports="d_selectedReportList" :p_isEligibleSelect="true" :key="d_selectedReportListKey"></analyze-report-view>
              </b-col>
            </b-row>
          </template>
          <template v-else-if="!d_reportLoading">
            <span>{{ 'no data' }}</span>
          </template>
        </template>



      </b-col>
    </b-row>

    

  </div>
</template>

<script>


import { ClsRule } from '@/wam/modules/rule';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsUser } from '@/wam/modules/user';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as WisdomDataModal
} from '@/wam/components/wdmr/WisdomDataModal';
import ServiceList from '@/wam/config/ServiceList.json';
import {
  default as RuleQuery
} from '@/wam/components/rule/RuleQuery';
import {
  default as WisdomDataShow
} from '@/wam/components/wdmr/WisdomDataShow';
import {
  default as WdmRuleA
} from '@/wam/components/rule/WdmRuleA';
import {
  default as AnalyzeReportView
} from '@/wam/components/widgets/AnalyzeReportView';
import { mapGetters } from 'vuex';
export default {
  name: 'report_view',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangTranslation: 'StoreLangTranslation',
  }),
  components: {
    WisdomDataModal,
    WisdomDataShow,
    WdmRuleA,
    RuleQuery,
    AnalyzeReportView,
  },
  props: {},
  data () {
    return {
      d_serviceList: ServiceList,
      d_ruleQueryData: '',
      d_dataLoading: false,
      d_temp: {},
      change: '0',
      d_editDataModal: {
        'show': false,
        'data': '',
      },
      d_showDataModal: {
        'show': false,
        'data': '',
      },
      d_selectedWdm: '',
      d_dataList: [],
      d_selectedReportList: [],
      d_dbQueryRuleShowModal: false,
      d_dbQueryRule: {
        'query_list': [],
        'compile_str_array': '',
        'compile_str_date': '',
        'compile_str_text': '',
      },
      d_selectedLayerCode: 'report',
      d_prepareRuleNew: {
        'mother_children': {
          'change_status': 0,
          'forceUpdate': 0
        },
        'date_ability': '',
        'wdmr_change': { 'rule': 0 },
        'data_type': '',
        'option_data': {},
        'prepare_data': {},
        'query_list': [],
        'compile_str_date': [],
        'compile_str_text': [],
        'compile_str_array': [],
        'wra_settings': {
          'mode': 'param',
          'options': [
            { 'label': 'PARAM', 'value': 'param' },
            { 'label': 'PARAM & QUERY', 'value': 'param_query' }
          ]
        },
        'wps_data': [{
          'operation': '',
          'selected_value': '',
          'loc': [],
          'val_list': [],
          'selected_wdm': '',
          'd_level': 0,
          'd_level_count': 0,
          'significant': 'true'
        }],
        'wdm_list': [],
      },
      d_wdmLoading: false,
      d_algorithmShow: true,
      d_parentClientId: '',
      d_clientId: '',
      d_isNew: true,
      d_clientPartList: {
        'application_name': '',
        'process': '',
        'user_type': '',
        'username': '',
        'report_type': '',
        'date': '',
      },
      d_selectedClientId : '',
      d_reportLoading: false,
      d_intervalId: null,
      d_refreshIntervalSec: 10,
      d_refreshIntervalSecTemp: 10,
      d_debounceTimer: null,
      d_fullScreen: true,
      d_changeTime: true,
      d_editOrNewReportShow: false,
      d_selectedReportListKey: '',
      d_bannedIpList: [],
      d_bannedSessionList: [],
      d_queryReportList: [],
      d_selectedTab: 'new_report',
      d_selectedTabIndex: '',
      d_tabList: [],
      d_tabTemplateList: [
        {
          'name': 'Website Unit Get Total',
          'clear_key': 'wai_web_frontend_websiteunit_get_totalcount',
        },
        {
          'name': 'Website Unit Get Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_frontend_websiteunit_get_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Frontend Websiteunit Get Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_frontend_websiteunit_get_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Register Total',
          'clear_key': 'wai_web_register_totalcount',
        },
        {
          'name': 'Register Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_register_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Register Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_register_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Login Total',
          'clear_key': 'wai_web_login_totalcount',
        },
        {
          'name': 'Login Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_login_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Login Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_login_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Get Token Total',
          'clear_key': 'wai_web_get_token_totalcount',
        },
        {
          'name': 'Get Token Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_get_token_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Get Token Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_get_token_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Wanalyzer Project Statistics Analyze List Total',
          'clear_key': 'wai_web_wanalyzer_project_statistics_analyze_list_totalcount',
        },
        {
          'name': 'Wanalyzer Project Statistics Analyze List Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_wanalyzer_project_statistics_analyze_list_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Wanalyzer Project Statistics Analyze List Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_wanalyzer_project_statistics_analyze_list_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Wanalyzer Machinelearning Train Total',
          'clear_key': 'wai_web_wanalyzer_machinelearning_train_totalcount',
        },
        {
          'name': 'Wanalyzer Machinelearning Train Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_wanalyzer_machinelearning_train_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Wanalyzer Machinelearning Train Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_wanalyzer_machinelearning_train_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Wanalyzer Project Save Total',
          'clear_key': 'wai_web_wanalyzer_project_save_totalcount',
        },
        {
          'name': 'Wanalyzer Project Save Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_wanalyzer_project_save_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Wanalyzer Project Save Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_wanalyzer_project_save_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'User Shopcart Bundle Add Total',
          'clear_key': 'wai_web_user_shopcart_bundle_add_totalcount',
        },
        {
          'name': 'User Shopcart Bundle Add Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_user_shopcart_bundle_add_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'User Shopcart Bundle Add Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_user_shopcart_bundle_add_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'User Shopcart Bundle Product Order Total',
          'clear_key': 'wai_web_user_shopcart_bundle_product_order_totalcount',
        },
        {
          'name': 'User Shopcart Bundle Product Order Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_user_shopcart_bundle_product_order_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'User Shopcart Bundle Product Order Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_user_shopcart_bundle_product_order_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'User Support New Total',
          'clear_key': 'wai_web_user_support_new_totalcount',
        },
        {
          'name': 'User Support New Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_user_support_new_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'User Support New Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_user_support_new_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Mail Support New Total',
          'clear_key': 'wai_web_mail_support_new_totalcount',
        },
        {
          'name': 'Mail Support New Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_mail_support_new_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Mail Support New Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_mail_support_new_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Search Text Total',
          'clear_key': 'wai_web_search_text_totalcount',
        },
        {
          'name': 'Search Text Today',
          'date_based': '1',
          'date_type': 'today',
          'before_date_key': 'wai_web_search_text_',
          'after_date_key': '_totalcount',
        },
        {
          'name': 'Search Text Last 5 Days',
          'date_based': '1',
          'date_type': 'last_x_days',
          'last_x_days': '5',
          'before_date_key': 'wai_web_search_text_',
          'after_date_key': '_totalcount',
        }
      ],
      d_newReportName: '',
      d_routeList: ['application_init'],
      d_selectedScope: 'web',      // system | web
      d_selectedLevel: '',
      d_selectedWebType: 'ip',    // all | user | ip | session
      d_selectedType: 'total',
      d_isDayBased: true,
      d_dayType: 'today',
      d_form: {
        'user': '',
        'ip': '',
        'session': '',
        'process_name': 'application_init',
        'query_key': '',
        'query_val': '',
        'last_x_days': '',
        'start_date': '',
        'end_date': '',
        'one_date': '',
      },

      d_reportModels: {
        'system': {
          'prefix': 'wai_sys',
          'targets': ['process_name'],
          'types': {
            'total': '_totalcount',
            'last_1': '_last1min',
            'last_5': '_last5min',
            'last_60': '_last60min',
            'last_100': '_last100'
          }
        },

        'web': {
          'all': {
            'prefix': 'wai_web',
            'targets_optional': ['process_name'],
            'types': {
              'total': '_totalcount',
              'last_1': '_last1min',
              'last_5': '_last5min',
              'last_60': '_last60min',
              'last_100': '_last100'
            },
            'types_for_list': {
              'total': '_totalcount'
            }
          },

          'user': {
            'prefix': 'wai_web',
            'addition': '_usr',
            'targets': ['user'],
            'targets_optional': ['process_name'],
            'types': {
              'total': '_totalcount',
              'query': '_{query_key}_{query_val}_totalcount',
              'last_1': '_last1min',
              'last_5': '_last5min',
              'last_60': '_last60min',
              'last_100': '_last100'
            },
            'types_for_list': {
              'total': '_totalcount'
            }
          },

          'ip': {
            'prefix': 'wai_web',
            'addition': '_ip',
            'targets': ['ip'],
            'targets_optional': ['process_name'],
            'types': {
              'total': '_totalcount',
              'query': '_{query_key}_{query_val}_totalcount',
              'last_1': '_last1min',
              'last_5': '_last5min',
              'last_60': '_last60min',
              'last_100': '_last100'
            },
            'types_for_list': {
              'total': '_totalcount'
            }
          },
          
          'session': {
            'prefix': 'wai_web',
            'addition': '_ses',
            'targets': ['session'],
            'targets_optional': ['process_name'],
            'types': {
              'total': '_totalcount',
              'query': '_{query_key}_{query_val}_totalcount',
              'last_1': '_last1min',
              'last_5': '_last5min',
              'last_60': '_last60min',
              'last_100': '_last100'
            },
            'types_for_list': {
              'total': '_totalcount'
            }
          }
        }
      },
      d_listQueryReportList: [],
      d_listQueryMergedReportList: [],
      d_listQueryReportType: '',
      d_listQueryReportProcess: '',
      d_reportTypeMatch: {
        'ip': '26',
        'user': '23',
        'session': '29',
      },
    };
  },
  created: function () {
    // this.f_getData();
    this.d_selectedWdm = '';
    this.d_tabList = JSON.parse(localStorage.getItem('selected_report_cl_id_list')) || [];
    if (this.d_tabList.length == 0) {
      this.d_tabList = JSON.parse(JSON.stringify(this.d_tabTemplateList));
      localStorage.setItem('selected_report_cl_id_list', JSON.stringify(this.d_tabList));
    }
    this.d_wdmLoading = true;
    ClsWdm.getLayerWdm(this.d_selectedLayerCode).then(resp_wdm_data => { 
      this.d_selectedWdm = resp_wdm_data; 
      this.d_wdmLoading = false;
      // this.f_openSearchRuleModal();
    });
    // console.log("d_selectedLayerCode: ",this.d_selectedLayerCode)
    // this.f_getData();
    // this.d_dataList = [];
    this.d_temp = {}

    for (let service_item of this.d_serviceList) {
      try {
        this.d_routeList.push(service_item.data.general.route_view.val)
      } catch {}
    }
    this.d_routeList.sort();
  },
  beforeMount () {},
  mounted: function () {},
  beforeDestroy() {
    if (this.d_intervalId) {
      clearInterval(this.d_intervalId);
      this.d_intervalId = null;
    }
  },
  methods: {
    f_addLastWeekReport: function (client_id) {
      if (this.d_listQueryReportType == 'ip') {
        client_id = client_id.replaceAll('.', '-');
      }
      let new_obj = {
        "name": "",
        "date_based": "1",
        "date_type": "last_x_days",
        "last_x_days": "7",
        "before_date_key": "",
        "after_date_key": "_totalcount"
      }
      if (this.d_listQueryReportProcess) {
        new_obj.before_date_key = "wai_web_" + this.d_listQueryReportType + "_" + client_id + "_" + this.d_listQueryReportProcess + "_"
        new_obj.name = this.d_listQueryReportType + " - " + client_id + " - " + this.d_listQueryReportProcess + " last 7 days "
      } else {
        new_obj.before_date_key = "wai_web_" + this.d_listQueryReportType + "_" + client_id + "_application_init_"
        new_obj.name = this.d_listQueryReportType + " - " + client_id + " - " + 'application_init' + " last 7 days "
      }
      this.d_tabList.unshift(new_obj)

      localStorage.setItem(
        'selected_report_cl_id_list',
        JSON.stringify(this.d_tabList)
      )
      alert(this.StoreLangTranslation.data['operation_completed'][this.StoreLang]);
    },
    f_listBasedQuery: function () {
      this.d_reportLoading = true;
      
      let query = '';
      let data = {
        'report_form': this.d_form,
      };
      if (this.d_selectedScope) {
        data.selected_scope = this.d_selectedScope; 
      }
      if (this.d_selectedLevel) {
        data.selected_level = this.d_selectedLevel;
      }
      if (this.d_selectedWebType) {
        data.selected_web_type = this.d_selectedWebType;
      }
      if (this.d_selectedType) {
        data.selected_type = this.d_selectedType;
      }
      if (this.d_isDayBased) {
        data.day_based = '1'
      } else {
        data.day_based = '0'
      }
      if (this.d_dayType) {
        data.day_type = this.d_dayType;
      }

      ServiceFunctions.list_based_report_query(query, data)
        .then(resp => {
          this.d_reportLoading = false;
          this.d_listQueryReportList = [];
          this.d_listQueryMergedReportList = [];
          this.d_listQueryReportType = '';
          this.d_listQueryReportProcess = '';
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              if (resp.data.sorted_list) {
                this.d_listQueryReportList = resp.data.sorted_list;
              } else if (resp.data.merged_list) {
                this.d_listQueryMergedReportList = resp.data.merged_list;
              }
              this.d_listQueryReportType = resp.data.type;
              this.d_listQueryReportProcess = resp.data.process_name;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });

    },
    f_build_report_object () {
      if (!this.d_selectedScope || !this.d_selectedType) return null

      let model = null

      if (this.d_selectedScope === 'system') {
        model = this.d_reportModels.system
      } else {
        model = this.d_reportModels.web[this.d_selectedWebType]
      }

      if (!model) return null

      let suffixTpl = model.types[this.d_selectedType]
      if (!suffixTpl) return null

      // suffix içindeki parametreler (örn {yyyymmdd}, {query_key})
      const needs = suffixTpl.match(/{(.*?)}/g) || []
      for (let m of needs) {
        const field = m.replace(/[{}]/g, '')
        if (!this.d_form[field]) return null
      }

      // prefix oluştur
      let baseKey = model.prefix
      if (model.addition) baseKey += model.addition

      // ⚠️ ZORUNLU TARGETS kontrolü
      const targets = model.targets || []
      if (targets.length) {
        for (let t of targets) {
          if (!this.d_form[t]) return null
          baseKey += '_' + this.d_form[t]
        }
      }

      // opsiyonel targets (opsiyonel de olsa girilmişse ekle)
      const optionalTargets = model.targets_optional || []
      optionalTargets.forEach(t => {
        if (this.d_form[t]) {
          baseKey += '_' + this.d_form[t]
        }
      })

      // 🟢 DAY BASED DEĞİL → CLEAR KEY
      if (!this.d_isDayBased && !suffixTpl.includes('{')) {
        return {
          name: this.d_newReportName,
          clear_key: baseKey + suffixTpl
        }
      }

      // 🟡 TODAY
      if (this.d_isDayBased && this.d_dayType === 'today') {
        return {
          name: this.d_newReportName,
          date_based: '1',
          date_type: 'today',
          before_date_key: baseKey + '_',
          after_date_key: suffixTpl.replace('_{yyyymmdd}', '')
        }
      }

      // 🔵 ONE DAY
      if (this.d_isDayBased && this.d_dayType === 'one_day') {
        if (!this.d_form.one_date) return null

        return {
          name: this.d_newReportName,
          date_based: '1',
          date_type: 'one_day',
          one_date: this.d_form.one_date,
          before_date_key: baseKey + '_',
          after_date_key: suffixTpl.replace('_{yyyymmdd}', '')
        }
      }

      // 🔴 LAST X DAYS
      if (this.d_isDayBased && this.d_dayType === 'last_x_days') {
        if (!this.d_form.last_x_days) return null

        return {
          name: this.d_newReportName,
          date_based: '1',
          date_type: 'last_x_days',
          last_x_days: this.d_form.last_x_days,
          before_date_key: baseKey + '_',
          after_date_key: suffixTpl.replace('_{yyyymmdd}', '')
        }
      }

      // 🟣 BETWEEN TWO DAYS
      if (this.d_isDayBased && this.d_dayType === 'between_two_days') {
        if (!this.d_form.start_date || !this.d_form.end_date) return null

        return {
          name: this.d_newReportName,
          date_based: '1',
          date_type: 'between_two_days',
          start_date: this.d_form.start_date,
          end_date: this.d_form.end_date,
          before_date_key: baseKey + '_',
          after_date_key: suffixTpl.replace('_{yyyymmdd}', '')
        }
      }

      return null
    },

    f_buildTabKeys(tab) {
      const response = {
        key_list: [],
        is_need_merge: '0'
      }

      if (!tab) return response

      // clear_key → tek eleman
      if (tab.clear_key) {
        response.key_list = [tab.clear_key]
        response.is_need_merge = '0'
        return response
      }

      if (String(tab.date_based) !== '1') {
        return response
      }

      const formatDate = (date) => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return y + m + d
      }

      // 🔹 TODAY
      if (tab.date_type === 'today') {
        const today = new Date()
        const dateStr = formatDate(today)

        response.key_list.push(
          tab.before_date_key + dateStr + tab.after_date_key
        )

        response.is_need_merge = '0'
        return response
      }

      // 🔹 ONE DAY
      if (tab.date_type === 'one_day') {
        if (tab.one_date) {
          response.key_list.push(
            tab.before_date_key + tab.one_date + tab.after_date_key
          )
          response.is_need_merge = '0'
        }
        return response
      }

      // 🔹 LAST X DAYS
      if (tab.date_type === 'last_x_days') {
        const days = parseInt(tab.last_x_days, 10)
        const today = new Date()

        response.is_need_merge = '1'

        for (let i = 0; i < days; i++) {
          const d = new Date(today)
          d.setDate(today.getDate() - i)

          response.key_list.push(
            tab.before_date_key + formatDate(d) + tab.after_date_key
          )
        }
        response.key_list.reverse()
        return response
      }

      // 🔹 BETWEEN TWO DAYS
      if (tab.date_type === 'between_two_days') {
        let current = new Date(
          tab.start_date.slice(0, 4),
          tab.start_date.slice(4, 6) - 1,
          tab.start_date.slice(6, 8)
        )

        const end = new Date(
          tab.end_date.slice(0, 4),
          tab.end_date.slice(4, 6) - 1,
          tab.end_date.slice(6, 8)
        )

        response.is_need_merge = '1'

        while (current <= end) {
          response.key_list.push(
            tab.before_date_key + formatDate(current) + tab.after_date_key
          )
          current.setDate(current.getDate() + 1)
        }

        return response
      }

      return response
    },

    f_removeTab: function (tab_index, e) {
      e.stopPropagation();
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_tabList.splice(tab_index, 1);
        localStorage.setItem('selected_report_cl_id_list', JSON.stringify(this.d_tabList));
        this.d_selectedTab = '';
      }
    },

    f_selectedTab: function (tab_type, tab_index) {
      this.d_selectedTab = tab_type;
      this.d_selectedTabIndex = tab_index;
      this.$forceUpdate();
    },

    f_addReportTab () {
      const report_obj = this.f_build_report_object()

      // geçersiz durum
      if (!report_obj) {
        if (this.$bvToast) {
          this.$bvToast.toast('Eksik veya hatalı alanlar var', {
            title: 'Uyarı',
            variant: 'warning',
            solid: true
          })
        }
        return
      }

      // liste yoksa oluştur
      if (!Array.isArray(this.d_tabList)) {
        this.d_tabList = []
      }

      // listeye ekle
      // this.d_tabList.push(report_obj)
      this.d_tabList.unshift(report_obj)

      // localStorage'a yaz
      localStorage.setItem(
        'selected_report_cl_id_list',
        JSON.stringify(this.d_tabList)
      )

      // form reset
      // this.f_resetReportBuilder()
      alert(this.StoreLangTranslation.data['operation_completed'][this.StoreLang]);
    },

    f_resetReportBuilder () {
      this.d_selectedScope = 'web'
      this.d_selectedWebType = ''
      this.d_selectedType = ''
      this.d_isDayBased = false
      this.d_dayType = ''
      this.d_newReportName = ''

      this.d_form = {
        'user': '',
        'ip': '',
        'session': '',
        'process_name': '',
        'query_key': '',
        'query_val': '',
        'last_x_days': '',
        'start_date': '',
        'end_date': ''
      }
    },

    f_build_key() {
      if (!this.d_selectedScope || !this.d_selectedType) return ''

      let model = null

      if (this.d_selectedScope === 'system') {
        model = this.d_reportModels.system
      } else {
        model = this.d_reportModels.web[this.d_selectedWebType]
      }

      if (!model) return ''

      // zorunlu targetlar
      const targets = model.targets || []
      for (let t of targets) {
        if (!this.d_form[t]) return ''
      }

      let suffix = model.types[this.d_selectedType]
      if (!suffix) return ''

      const matches = suffix.match(/{(.*?)}/g) || []
      for (let m of matches) {
        const field = m.replace(/[{}]/g, '')
        if (!this.d_form[field]) return ''
        suffix = suffix.replace(m, this.d_form[field])
      }

      let key = model.prefix
      if (model.addition) key += model.addition

      targets.forEach(t => {
        key += '_' + this.d_form[t]
      })

      return key + suffix
    },
    f_needs(field) {
      if (!this.d_selectedLevel || !this.d_selectedType) return false

      return this.d_reportModels[this.d_selectedLevel]
        .types[this.d_selectedType]
        .includes(`{${field}}`)
    },

    f_getBannedIpList: function () {
      this.d_reportLoading = true;
      this.d_bannedIpList = [];
      let query = '';
      let data = {};
      ServiceFunctions.banned_ip_list(query, data)
        .then(resp => {
          this.d_reportLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              // console.log(resp.data.list);
              this.d_bannedIpList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getBannedSessionList: function () {
      this.d_reportLoading = true;
      this.d_bannedSessionList = [];
      let query = '';
      let data = {};
      ServiceFunctions.banned_session_list(query, data)
        .then(resp => {
          this.d_reportLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              // console.log(resp.data.list);
              this.d_bannedSessionList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },

    f_getSelectedReports: function () {
      
      if (this.d_tabList.length > 0) {
        this.d_reportLoading = true;
        let { key_list, is_need_merge } = this.f_buildTabKeys(this.d_tabList[this.d_selectedTabIndex]);
        
        let query = '';
        let data = {
          'report_cl_id_list': key_list,
          'merge_reports': is_need_merge
        };
        if (is_need_merge == '1') {
          data['merge_report_name'] = this.d_tabList[this.d_selectedTabIndex]['name'];
        }

        ServiceFunctions.report_list(query, data)
          .then(resp => {
            this.d_reportLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              if (resp.data.list) {
                // console.log(resp.data.list);
                this.d_selectedReportList = resp.data.list;
                this.d_selectedReportListKey = Date.now();
                // let temp_tab_list = JSON.parse(JSON.stringify(this.d_tabList))

                
                // for (let selected_cl_index in this.d_tabList) {
                //   if (this.d_tabList[selected_cl_index]['key'] === selected_tab) {
                //     let include_data = false;
                //     for (let data_index in this.d_selectedReportList) {
                //       if (this.d_tabList[selected_cl_index]['key'] === this.d_selectedReportList[data_index].client_id) {
                //         include_data = true;
                //         break
                //       }
                //     }
                //     if (!include_data) {
                //       alert(this.StoreLangTranslation.data['report_not_found'][this.StoreLang] + '' + this.d_tabList[selected_cl_index]['key'])
                //       // this.d_tabList.splice(selected_cl_index, 1);
                //       // this.d_selectedTab = 'new_report';
                //     }
                //   }
                // }
                


              } else {
                alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_changeAlgorithmShow: function (new_val) {
      this.d_algorithmShow = new_val;
    },
    f_copyClientId: function (clientId) {
      if (!clientId) return;
      navigator.clipboard.writeText(clientId)
        .then(() => {
          // console.log("Client ID kopyalandı:", clientId);
        })
        .catch(err => {
          console.log("error:", err);
        });
    },

    f_closeWdmrEditModal: function () {
      this.d_editDataModal.show = false;
    },
    f_saveWdmr: function () {
      // console.log('save data: ', this.d_editDataModal.data);
      let query = '';
      query += 'layer_code=' + this.d_selectedLayerCode
      if (this.d_editDataModal.data['client_id']) {
        query += '&cl_id=' + encodeURIComponent(this.d_editDataModal.data['client_id']);
      }
      else if (this.d_clientId) {
        query += '&cl_id=' + encodeURIComponent(this.d_clientId)
      }
      if (this.d_editDataModal.data['parent_c']) {
        query += '&p_id=' + encodeURIComponent(this.d_editDataModal.data['parent_c']['id'])
        // query += '&p_ly_id=' + this.d_editDataModal.data['parent_c']['ly_id']
      }
      else if (this.d_parentClientId) {
        query += '&p_id=' + encodeURIComponent(this.d_parentClientId)
      }
      let data = {
        'wdmr_data': this.d_editDataModal.data,
      };
      ServiceFunctions.db_record(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            alert("başarılı")
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_selectLayerCode: function (layer_code) {
      this.d_selectedLayerCode = layer_code;
    },
    f_openSearchRuleModal: function () {
      this.d_dbQueryRule = JSON.parse(JSON.stringify(this.d_prepareRuleNew));
      let new_wdm_item = {'type': this.d_selectedLayerCode, 'value': this.d_selectedLayerCode, 'label': this.d_selectedLayerCode};
      this.d_dbQueryRule.wdm_list.push(new_wdm_item);
      this.d_dbQueryRule.option_data[this.d_selectedLayerCode] = this.d_selectedWdm;
      this.$set(this.d_dbQueryRule, 'query_list', this.d_temp.query_list || []);
      this.$set(this.d_dbQueryRule, 'compile_str_array', this.d_temp.compile_str_array || []);
      this.$set(this.d_dbQueryRule, 'compile_str_date', this.d_temp.compile_str_date || []);
      this.$set(this.d_dbQueryRule, 'compile_str_text', this.d_temp.compile_str_text || []);
      this.d_dbQueryRuleShowModal = true;
    },
    f_acceptMainRule: function () {
      let parenthesis_control = ClsRule.f_controlParanthesisDesign(this.d_dbQueryRule.compile_str_array);
      // console.log('parenthesis_control : ', parenthesis_control);
      if (parenthesis_control) {
        if (this.d_dbQueryRule.wra_settings.mode === 'param') {
          ClsRule.f_paramToQuery(this.d_dbQueryRule.query_list, this.d_dbQueryRule.compile_str_array, this.d_dbQueryRule.wps_data);
        }
        this.d_ruleQueryData = {
          'query_list': this.d_dbQueryRule.query_list,
          'compile_str_array': this.d_dbQueryRule.compile_str_array,
          'compile_str_date': this.d_dbQueryRule.compile_str_date,
          'compile_str_text': this.d_dbQueryRule.compile_str_text
        };
        this.d_temp = {
          'query_list': this.d_dbQueryRule.query_list,
          'compile_str_array': this.d_dbQueryRule.compile_str_array,
          'compile_str_date': this.d_dbQueryRule.compile_str_date,
          'compile_str_text': this.d_dbQueryRule.compile_str_text
        };

        let query = '';
        let data = {
          'rule_data': this.d_ruleQueryData,
          'wdmr_list_id': '',
          'wdmr_list_id_count': '',
          'layer_code': this.d_selectedLayerCode,
        };
        this.d_dataLoading = true;
        ServiceFunctions.db_layer_query(query, data)
          .then(resp => {
            this.d_dataLoading = false;
            this.d_dataList = [];
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              for (let i in resp.data.sql_result_list['paramorder']) {
                this.d_dataList.push(resp.data.sql_result_list['parameters'][resp.data.sql_result_list['paramorder'][i]]);
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });

        // console.log('this.d_ruleQueryData ', this.d_ruleQueryData);
        this.d_dbQueryRuleShowModal = false;
      } else {
        alert(this.StoreLangTranslation.data['please_check_parenthesis'][this.StoreLang]);
      }
    },
    f_calculateLayerDetailsTableStyle: function () {
      let style = 'overflow-x: auto; overflow-y: auto; width: 100%; border: solid 1px blue;';
      let height = 'height: ' + (window.innerHeight - 300).toString() + 'px;';
      style += height;
      return style;
    },
    f_editWdmrDocument: function (row) {
      // console.log(row);
      const isNotRow = (row === undefined);  

      if (isNotRow) {
        row = {'data': {}};
        this.d_isNew = true;
      } else {
        this.d_isNew = false;
      }
      this.d_parentClientId = ''
      this.d_clientId = ''
      this.d_editDataModal.data = row;
      this.d_editDataModal.data_type = this.d_selectedLayerCode;
      this.d_editDataModal.option_data = {};
      this.d_editDataModal.option_data[this.d_selectedLayerCode] = this.d_selectedWdm;
      this.d_editDataModal.show = true;
    },
    f_showWdmrDocument: function (row) {
      // console.log(row);
      this.d_showDataModal.data = row;
      this.d_showDataModal.data_type = this.d_selectedLayerCode;
      this.d_showDataModal.option_data = {};
      this.d_showDataModal.option_data[this.d_selectedLayerCode] = this.d_selectedWdm;
      this.d_showDataModal.show = true;
    },
    f_getData: function () {
      if (this.d_selectedLayerCode) {
        this.d_dataList = [];
        let query = 'layer_code=' + this.d_selectedLayerCode;
        let data = {};
        ServiceFunctions.db_data_get(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              this.d_dataList = resp.data.list;
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    }
  },
  watch: {
    'd_selectedTab': function () {
      if (this.d_intervalId) {
        clearInterval(this.d_intervalId);
        this.d_intervalId = null;
      }
      if (this.d_selectedTab === 'banned_ip_list') {
        this.f_getBannedIpList();
      } else if (this.d_selectedTab === 'banned_session_list') {
        this.f_getBannedSessionList();
      }
      this.d_selectedReportList = '';
      this.d_selectedReportListKey = '';
      this.d_listQueryReportList = [];
      this.d_listQueryMergedReportList = [];

      if (this.d_selectedTab === 'new_report') {
        this.d_selectedWebType = 'ip';
        this.d_isDayBased = true;
        this.d_dayType = 'today';
        this.d_form = {
          'user': '',
          'ip': '',
          'session': '',
          'process_name': 'application_init',
          'query_key': '',
          'query_val': '',
          'last_x_days': '',
          'start_date': '',
          'end_date': '',
          'one_date': '',
        };
      } else if (this.d_selectedTab === 'list_based_query') {
        this.d_selectedWebType = 'ip';
        this.d_isDayBased = true;
        this.d_dayType = 'today';
        this.d_form = {
          'user': '',
          'ip': '',
          'session': '',
          'process_name': 'application_init',
          'query_key': '',
          'query_val': '',
          'last_x_days': '',
          'start_date': '',
          'end_date': '',
          'one_date': '',
        };
      }
    },
    'd_selectedTabIndex': function () {
      if (this.d_selectedTabIndex !== '') {
        if (this.d_intervalId) {
          clearInterval(this.d_intervalId);
          this.d_intervalId = null;
        }
        if (!this.d_reportLoading) {
          this.f_getSelectedReports();
          this.d_intervalId = setInterval(() => {
            this.f_getSelectedReports();
          }, 10000);
        }
        this.d_selectedReportList = '';
        this.d_selectedReportListKey = '';
      }
    },
    'd_form': {
      deep: true,
      handler: function () {
        this.f_build_key()
      }
    },

    'd_selectedLevel': function () {
      this.d_selectedType = '';
      // this.f_build_key()
    },

    'd_isDayBased': function () {
      if (this.d_isDayBased) {
        this.d_selectedType = 'total';
      } else {
        this.d_selectedType = '';
      }
    },

    'd_selectedType': function () {
      this.f_build_key()
    },
    // 'd_selectedLayerCode': function () {
    //   if (!this.d_wdmLoading) {
    //     this.d_selectedWdm = '';
    //     this.d_wdmLoading = true;
    //     ClsWdm.getLayerWdm(this.d_selectedLayerCode).then(resp_wdm_data => { 
    //       this.d_selectedWdm = resp_wdm_data; 
    //       this.d_wdmLoading = false;
    //       this.f_openSearchRuleModal();
    //     });
    //     // console.log("d_selectedLayerCode: ",this.d_selectedLayerCode)
    //     // this.f_getData();
    //     this.d_dataList = [];
    //     this.d_temp = {}
    //   }
    // },
    '$route.name': function () {
      // this.f_getData();
    },
    'd_selectedClientId': function () {
      // this.f_getSelectedReports();
    },

    'd_refreshIntervalSecTemp': function () {
      this.d_changeTime = false;
      if (this.d_refreshIntervalSecTemp && this.d_refreshIntervalSecTemp > 0) {
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = setTimeout(() => {
          this.d_changeTime = true;
          this.d_refreshIntervalSec = this.d_refreshIntervalSecTemp;
          this.debounceTimer = null;
          if (this.d_intervalId) {
            clearInterval(this.d_intervalId);
            this.d_intervalId = null;
          }
          this.d_intervalId = setInterval(() => {
            this.f_getSelectedReports();
            // this.f_getSelectedReports();
          }, this.d_refreshIntervalSec * 1000);
        }, 3000);
      }
    }

  }
}

</script>

<style>
  
.report-tab-list {
  border-right: 1px solid #e5e7eb;
  padding-right: 8px;
}

.report-tab-item {
  padding: 10px 12px;
  margin-bottom: 6px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  transition: all 0.15s ease-in-out;
}

.report-tab-item:hover {
  background-color: #f3f4f6;
}

.report-tab-item.active {
  background-color: #e0f2fe;
  color: #0369a1;
  font-weight: 600;
  border-left: 3px solid #0284c7;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

.normal-mode {}

.full-screen-mode {
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*background-color: rgba(0, 0, 0, .5);*/
  /*display: table;*/
/*  -webkit-transition: opacity .3s ease;
  transition: opacity .3s ease;
*/
}

</style>